'use strict';

var React = require('react');

var SvgMinusMajor = function SvgMinusMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2 10a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2h-14a1 1 0 0 1-1-1Z"
  }));
};

exports.SvgMinusMajor = SvgMinusMajor;
